
// import img
import Image from '../assets/img/about.webp';

const About = () => {
  return (
    <section className='section bg-secondary' id='about'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row gap-24'>
          <img
            className='object-cover h-full w-[566px] md:mx-auto lg:mx-0 rounded-2xl'
            src={Image}
            alt=''
          />
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left'>
            <div className='flex flex-col'>
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                Shakil Kamran
              </h2>
              <p className='mb-4 text-accent'>
                Freelance Full stack web Application Developer
              </p>
              <hr className='mb-8 opacity-5' />
              <p className='mb-8'>
              Hey,I have 2+ years experience in Responsive design(TailwindCSS, Custom CSS or Rect StyledComponet) and any MERN Stack Project, very much experienced in 
            Javascript, React and node js, Typescript, Graphql, redux toolkit along with necessary software tools and technologies. <br />
                <br />
                UI/UX design is also included in our service by Tailwind CSS, Custom css or React Styled components.
              </p>
            </div>
            <button className='btn btn-md bg-accent hover:bg-secondary-hover transition-all'>
              Contact me
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
